import Svg, { Path, Rect } from 'react-native-svg';
import { withDefaultIconProps, type MinimalSvgProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const CheckCircle2 = withDefaultIconProps(
  {
    height: 32,
    width: 32,
    color: theme.colors['text.brand'],
  },
  ({ color, fillColor, ...rest }: MinimalSvgProps & { fillColor?: string }) => (
    <Svg {...rest} viewBox="0 0 32 32">
      <Rect fill={fillColor} height="32" rx="16" width="32" />
      <Path
        clipRule="evenodd"
        d="M22.3 10.89C22.92 11.49 22.93 12.48 22.33 13.1L14.12 21.55L9.67 16.98C9.07 16.36 9.08 15.37 9.7 14.77C10.32 14.16 11.31 14.18 11.91 14.8L14.12 17.07L20.09 10.92C20.69 10.3 21.68 10.29 22.3 10.89Z"
        fill={color}
        fillRule="evenodd"
      />
    </Svg>
  ),
);
